// Temporary file which can be moved to another file/folder later


import { AccountInfo } from '../../Models/AccountInfo';
import { useAtom } from 'jotai/index';
import { AccountInfoAtom } from '../../store/AccountStore';

export function isSubscribed(accountInfo?: AccountInfo): boolean {
    if (accountInfo.subscription.status === 'Active' || accountInfo.subscription.status === 'Admin') {
        return true;
    }

    return false;
}

export function useIsSubscribed(): boolean {
    const [accountInfo] = useAtom(AccountInfoAtom);

    if (accountInfo) {
        return accountInfo.subscription.status === 'Active' || accountInfo.subscription.status === 'Admin';
    }

    return false;
}